import { ICreateMotivoAfastamentoUseCase } from "../../../presentation/useCases/create/create_motivo_afastamento_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * CreateMotivoAfastamentoUseCase
 */

export class CreateMotivoAfastamentoUseCase implements ICreateMotivoAfastamentoUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async createMotivoAfastamento(
    ativo: number,
    descricaoMotivo: string,
  ): Promise<void> {
    await this.repository.createMotivoAfastamento(
      ativo === 1,
      descricaoMotivo,
    );
  }
}